// extracted by mini-css-extract-plugin
export default {"info_banner":"ReadOnlyBanner_info_banner__1JI-I","info_banner_content":"ReadOnlyBanner_info_banner_content__Zsp3x"};